<ez-section>
  <ez-block>
    <div class="phms-intake-submission-detail">
      <div class="page-header">
        <div>
          <h2>{{ pageTitle }}</h2>
        </div>
        <div class="page-header__actions">
          <a class="back-link" [routerLink]="['/phms/intake-submissions']">Back to intake submissions</a>
        </div>
      </div>

      <p class="loading-text" *ngIf="isLoading()" role="status" aria-live="polite">
        Loading intake submission...
      </p>

      <div class="message-box error" *ngIf="errorState() as error" role="alert" aria-live="assertive">
        <p>{{ error.title }}</p>
        <ul>
          <li *ngFor="let message of error.messages">{{ message }}</li>
        </ul>
      </div>

      <ng-container *ngIf="!isLoading() && intakeSubmission() as intakeSubmission">
        <dl class="intake-submission-fields">
          <div>
            <dt>{{ nameLabel() }}</dt>
            <dd>{{ intakeSubmission.incarceratedPersonDisplayName }}</dd>
          </div>
          <div>
            <dt>{{ identifierLabel() }}</dt>
            <dd>{{ intakeSubmission.incarceratedPersonIdentifier }}</dd>
          </div>
          <div>
            <dt>{{ programScopeKeyLabel() }}</dt>
            <dd>{{ intakeSubmission.programScopeKey }}</dd>
          </div>
          <div>
            <dt>{{ operationalText.status() }}</dt>
            <dd>{{ intakeSubmission.intakeStatusCode }}</dd>
          </div>
          <div>
            <dt>Received</dt>
            <dd>{{ intakeSubmission.intakeAtUtc | date: 'medium' }}</dd>
          </div>
        </dl>
        <p class="intake-submission-case-context-link">
          <a
            class="case-context-link"
            data-testid="case-context-entry-link"
            [routerLink]="['/case-context/inmate', intakeSubmission.id]"
          >{{ subjectText.openCaseContext() }}</a>
        </p>
      </ng-container>
    </div>
  </ez-block>
</ez-section>

